const COOKIE_NAME = 'alsocookie';

export default () => {
  const cookie = getCookie(COOKIE_NAME);

  if (cookie === null)
  {
    const $wrapper = $(".cookie_bar__wrapper");

    $wrapper.show("fast");

    $(".button--cookie").on('click', () => {
      //document.cookie = "ags=1;";
      setCookie(COOKIE_NAME, "1");
      $wrapper.hide("fast");
    });
  }
}

function getCookie(name) {
  let end;
  const dc = document.cookie;
  const prefix = name + "=";
  let begin = dc.indexOf("; " + prefix);

  if (begin === -1)
  {
    begin = dc.indexOf(prefix);
    if (begin !== 0) return null;
  }
  else
  {
    begin += 2;
    end = document.cookie.indexOf(";", begin);
    if (end === -1)
    {
      end = dc.length;
    }
  }

  return unescape(dc.substring(begin + prefix.length, end));
}

function setCookie(name, value) {
  const date = new Date();
  date.setTime(date.getTime() + 50 * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();

  document.cookie = name + "=" + value + expires + ";path=/";
}
